import { Button } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';
import Text from 'src/new_arch/modules/ui/components/Text/Text';
import PropTypes from 'prop-types';
import useFetchCurrentUserQuery from 'src/new_arch/modules/authentication/queries/useFetchCurrentUserQuery';

type Props = {
  label?: string;
  onClick?: ( e: React.MouseEvent<HTMLButtonElement> ) => void;
  className?: string;
};

const AnalyticsButton: React.FC<Props> = ( { label = '2025 Analytics', className } ) => {
	const { data: currentUser } = useFetchCurrentUserQuery();

	if ( !currentUser?.hasMetrics ) {
		return null;
	}

	return (
		<Button
			variant="outline"
			leftIcon={<Icon icon="assessment_outlined" size={18} color="white" />}
			radius="sm"
			size="sm"
			m={0}
			p={4}
			color="gray"
			className={className}
			onClick={() => window.open( `/user-metrics/${currentUser?.userHash}`, '_blank' )}
			styles={{
				leftIcon: { marginRight: 6 },
				root: {
					'&:hover': {
						backgroundColor: 'transparent',
						borderColor: 'var(--color-outline-default)'
					}
				}
			}}
		>
			<Text color="white">{label}</Text>
		</Button>
	);
};

export default AnalyticsButton;

AnalyticsButton.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string
};
